import { PageHeader } from "@/components/bespoke";
import { NotConnectedState } from "@/components/states";
import { Card, CardContent } from "@/components/ui/card";

export function PlaceholderPage({ title }: { title: string }) {
  return (
    <>
      <PageHeader title={title} />
      <Card className="max-w-xl">
        <CardContent>
          <NotConnectedState
            title={`${title} is not connected yet`}
            description="This surface needs its backend capability before it can do anything useful."
          />
        </CardContent>
      </Card>
    </>
  );
}

export function NotFoundPage() {
  return (
    <PageHeader
      title="Page not found"
      description="This address does not exist, or you do not have access to it."
    />
  );
}
